import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-tdo-multiselect-dropdown',
  templateUrl: './tdo-multiselect-dropdown.component.html',
  styleUrls: ['./tdo-multiselect-dropdown.component.css']
})
export class TdoMultiselectDropdownComponent implements OnInit {

  constructor() { }
  @ViewChild('allSelected') private allSelected: MatOption;
  allSelectedValue: string = '72e3e723-4042-41d7-8e3d-50a2844850b7';

  @Output() onChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() placeholder: string = '';
  @Input() multiple: boolean = true;
  @Input() items: any[] = [];
  @Input() valueExp: string = '';
  @Input() displayExp: string = '';
  @Input() selectedItems: any[] = [];
  @Input() editable: boolean = true;
  @Input() isShowAllOption = true;
  @Input() color = 'black';

  formControl = new UntypedFormControl();

  public uneditableItems: any[] = [];

  private curr: any[] = [];

  ngOnInit() {
    if (this.selectedItems.length === this.items.length) {
      if (this.isShowAllOption) {
        this.formControl.setValue([...this.selectedItems, this.allSelectedValue]);
      } else {
        this.formControl.setValue([...this.selectedItems]);
      }
    }
    else {
      this.formControl.setValue([...this.selectedItems]);
    }

    if (!this.editable) {
      this.uneditableItems = this.items.filter(o => {
        if (this.valueExp.trim() === '') {
          const found = this.selectedItems.find(p => p === o);
          return found !== null && found !== undefined;
        }
        else {
          const found = this.selectedItems.find(p => p === o[this.valueExp]);
          return found !== null && found !== undefined;
        }
      });
    }
  }

  public selectAll(): void {
    if (!this.editable) {
      return;
    }

    this.allSelected.select();
    this.toggleAllSelection();
    this.onChange.emit(this.formControl.value.filter(o => o !== this.allSelectedValue));
  }

  public deselectAll(): void {
    if (!this.editable) {
      return;
    }

    this.allSelected.deselect();
    this.toggleAllSelection();
    this.onChange.emit([]);
  }

  public compareCategoryObjects(object1: any, object2: any) {
    if (!this.valueExp || this.valueExp.trim() === '') {
      return object1 && object2 && object1 === object2;
    }
    else {
      return object1 && object2 && object1[this.valueExp] === object2[this.valueExp];
    }
  }

  public toggleAllSelection() {
    if (this.allSelected.selected) {
      this.formControl.setValue([...this.items.map(o => this.valueExp.trim() === '' ? o : o[this.valueExp]), this.allSelectedValue]);
    } else {
      this.formControl.patchValue([]);
    }
  }

  public getDisplayValue(value: any): void {
    if (this.valueExp.trim() === '') {
      const foundValue = this.items.find(o => o === value);
      return foundValue ? foundValue : '';
    }
    else {
      const foundValue = this.items.find(o => o[this.valueExp] === value);
      return foundValue ? foundValue[this.displayExp] : '';
    }
  }
  public onChanged(event: boolean): void {
    if (!this.editable) {
      return;
    }

    if (event) {
      this.curr = this.formControl.value.filter(o => o !== this.allSelectedValue);
    }
    else {

      console.log(this.formControl);

      let toReturn: any[];

      if (this.multiple) {
        toReturn = this.formControl.value.filter(o => o !== this.allSelectedValue);
      } else {
        toReturn = [this.formControl.value];
      }

      // if there was stuff when window opened now has no stuff that's a change
      if (this.curr.length !== 0 && toReturn.length === 0) {
        this.onChange.emit(toReturn);
        return;
      }
      else {
        if (this.curr.length !== toReturn.length) {
          this.onChange.emit(toReturn);
          return;
        }
        else {
          for (let i = 0; i < this.curr.length; i++) {
            if (!toReturn.some(o => o === this.curr[i])) {
              this.onChange.emit(toReturn);
              return;
            }
          }
        }
      }
    }
  }
}
